module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "revision-history-branch"
  }, [_c('div', {
    staticClass: "revision-history-branch__header"
  }, [_c('span', {
    staticClass: "revision-history-branch__label"
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]), _vm._v(" "), _c('x-flag', {
    attrs: {
      "scale": 1.2
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteBranch.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "revision-history-branch__footer"
  }, [_c('span', [_c('span', {
    staticClass: "revision-history-branch__audience"
  }, [_vm._v("\n        " + _vm._s(_vm.totalAudience) + "\n      ")]), _vm._v(" "), (!_vm.isCurrentBranch) ? [_c('positiveity-indicator', {
    attrs: {
      "number": _vm.changeInAudience,
      "message": _vm.changeInAudienceMessage
    }
  }), _vm._v(" "), _c('oval-button', {
    staticClass: "revision-history-branch__goto",
    nativeOn: {
      "click": function($event) {
        return _vm.goto.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          GOTO\n        ")])] : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19158483"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/revisionHistory/Branch.vue
// module id = 1828
// module chunks = 0